import React from "react";
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";
import "./Page.css";

const Container = styled.div({
  width: "81.5%",
  margin: "auto",
  padding: "0px",
});

const Img = styled.img({
  maxHeight: "100%",
  maxWidth: "100%",
  objectFit: "cover",
  // boxShadow: '3px 3px 3px 3px lightgray'
});

const Page = (props) => {
  const url = `${process.env.REACT_APP_API}/images/${props.documentId}/${
    props.page - 1
  }/${props.openId}`;
  return (
    <Container className="no-visual-search d-flex justify-content-center "
    //  className={
    //     props.classDiv != "" ? "no-visual-search d-flex justify-content-center " + props.classDiv : "no-visual-search d-flex justify-content-center"
    //   }

    >
      <Img
        id="page"
        src={url}
        className={props.class}
        alt="Page Not Found"
        align="left"
      />
    </Container>
  );
};

export default Page;
